import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { UnidadMedidaCultivo } from '../../../_models/unidad-medida-cultivo';
import { NavService } from '../../../_services/_nav.service';

@Component({
  selector: 'app-unidades-medida-listado',
  templateUrl: './unidades-medida-listado.component.html',
  styleUrls: ['./unidades-medida-listado.component.css']
})
export class UnidadesMedidaListadoComponent implements OnInit {
  @Output() dismiss: EventEmitter<any> = new EventEmitter();

  @Input() unidadesMedidasCultivo: UnidadMedidaCultivo[] = [];
  columnas: any[] = [];
  cargandoTabla = true;
  @ViewChild('dt', { static: true }) tabla: Table;
  busqueda: string;

  constructor(
    private navServicio: NavService,
    
  ) { }

  ngOnInit() {
    this.setColumnasTabla();
  }

  

  setColumnasTabla() {
    this.columnas = [
      {
        field: 'codigo',
        header: this.navServicio.buscarMensaje('ESTRUCTURAAGRICOLA.LBL_CODIGO'),
        sort: false,
      },
      {
        field: 'unidad-medida',
        header: this.navServicio.buscarMensaje('ESTRUCTURAAGRICOLA.LBL_UNIDADDEMEDIDA'),
        sort: false,
      },
      {
        field: 'equivalencia-kg',
        header: this.navServicio.buscarMensaje('ESTRUCTURAAGRICOLA.LBL_EQUIVALENCIAKG'),
        sort: false,
      },
      {
        field: 'indicador-habilitado',
        header: this.navServicio.buscarMensaje('ESTRUCTURAAGRICOLA.LBL_HABILITADO'),
        sort: false,
      },
      {
        field: 'acciones',
        header: this.navServicio.buscarMensaje('ESTRUCTURAAGRICOLA.LBL_ACCIONES'),
        sort: false,
      },
    ];
    this.busqueda = this.navServicio.getSearch('alerta.component');
    this.cargandoTabla = false;
    this.tabla.filterGlobal(this.busqueda, 'contains');
  }

  agregar() {
    const data =
    {seccion: 'FORM'};
    this.dismiss.emit(data);
  }

  editarUnidad(unidadMedidaCultivo) {
    const data = {
      seccion: 'FORM',
      data: unidadMedidaCultivo
    };
    this.dismiss.emit(data);
  }
}
